import {RootState} from "../../../../store";

export const getConstantsProblems = (state: RootState) => state.constantsReducer.interestProblem;
export const getProblems = (state: RootState) => state.constantsReducer.interestProblem.collection;
